export default "__VITE_ASSET__4d77d31a__"